import React, { useState } from 'react';
import { prepareData } from 'utils/googleData';
import { GatsbyImage } from 'gatsby-plugin-image';

export function HowItWorks(props) {
  // console.log('props', props.data.pageData.nodes[0].parent.images)
  const {
    enable,
    title,
    subtitle,
    cards,
  } = prepareData({ props });

  const [activeIndex, setActiveIndex] = useState(0);

    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }

  return (
    <section className="safe-paddings py-24 bg-[#0B1C39] md:py-20 sm:py-16">
      <div className="container max-w-7xl mx-auto px-4">

        {/* Title and Subtitle */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-white">
            {title.split('Easy').map((part, index) => (
              <React.Fragment key={index}>
                {part}
                {index === 0 && <span className="text-[#4BB3FD]">Easy</span>}
              </React.Fragment>
            ))}
          </h2>
          <p className="text-white/80 text-lg lg:text-xl max-w-3xl mx-auto">
            {subtitle}
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Steps Column */}
          <div className="space-y-8">
            {cards?.map((card, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-full text-left p-6 rounded-lg transition-all duration-300 ${
                  activeIndex === index 
                    ? 'bg-[#1B3154] border-l-4 border-[#4BB3FD] shadow-lg shadow-black/10' 
                    : 'hover:bg-[#1B3154]/50'
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-semibold ${
                    activeIndex === index 
                      ? 'bg-[#4BB3FD] text-white'
                      : 'bg-[#2C4268] text-white/90'
                  }`}>
                    {index + 1}
                  </div>
                  <div>
                    <h3 className={`text-xl font-bold mb-2 ${
                      activeIndex === index ? 'text-[#4BB3FD]' : 'text-white'
                    }`}>
                      {card.title}
                    </h3>
                    <p className="text-white/80 leading-relaxed">
                      {card.description}
                    </p>
                  </div>
                </div>
              </button>
            ))}
          </div>

          {/* Image Column */}
          <div className="relative lg:sticky lg:top-8 h-full">
            <div className="h-full min-h-[600px] rounded-lg overflow-hidden shadow-xl shadow-black/20">
              {cards?.[activeIndex]?.gatsbyImage && 
              (
                <GatsbyImage
                  image={cards[activeIndex].gatsbyImage}
                  alt={cards[activeIndex].title}
                  className="w-full h-full transition-opacity duration-300"
                  objectFit="cover"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default HowItWorks;